import React, { useEffect, useState } from "react";
import SideOrderDetails from "./SharedModule/SideOrderDetails";
import HeadOrderDetails from "./SharedModule/HeadOrderDetails";
import Select from "react-select";
import "./Activity.css";
import axios from "axios";
import NotFound from "./SharedModule/NotFound";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import DeleteModal from "./Modals/DeleteModal";

export default function Activity() {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const [isActivityModal, setIsActivityModal] = useState(false);

  const toggleActivityModal = () => {
    if (isActivityModal) {
      setSelectedCallType(null);
      setSelectedCallStatus(null);
      setSelectedActivityType(null);
      setClientComments("");
      setAgentNotes("");
    }
    setIsActivityModal(!isActivityModal);
  };

  const [isCommentsVisible, setIsCommentsVisible] = useState({});

  const toggleComments = (logId) => {
    setIsCommentsVisible((prevState) => ({
      ...prevState,
      [logId]: !prevState[logId],
    }));
  };

  const { id } = useParams();

  const [activityLogs, setActivityLogs] = useState([]);

  const [activityTypes, setActivityTypes] = useState([]);

  const [callTypes, setCallTypes] = useState([]);

  const [callStatus, setCallStatus] = useState([]);

  const [selectedActivityType, setSelectedActivityType] = useState("");
  const [selectedCallType, setSelectedCallType] = useState("");
  const [selectedCallStatus, setSelectedCallStatus] = useState("");
  const [clientComments, setClientComments] = useState("");
  const [agentNotes, setAgentNotes] = useState("");
  const [scheduledDate, setScheduledDate] = useState("");
  const [scheduledFrom, setScheduledFrom] = useState("");
  const [scheduledTo, setScheduledTo] = useState("");
  const [cancellationReason, setCancellationReason] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [editingLogId, setEditingLogId] = useState(null);
  const [editedActivityType, setEditedActivityType] = useState("");
  const [editedCallType, setEditedCallType] = useState("");
  const [editedCallStatus, setEditedCallStatus] = useState("");
  const [editedComments, setEditedComments] = useState("");
  const [editedAgentNotes, setEditedAgentNotes] = useState("");
  const [editedCancellationReason, setEditedCancellationReason] = useState("");
  const [editedScheduledDate, setEditedScheduledDate] = useState("");
  const [editedScheduledFrom, setEditedScheduledFrom] = useState("");
  const [editedScheduledTo, setEditedScheduledTo] = useState("");

  const handleActivityTypeEdited = (selectedOption) => {
    setEditedActivityType(selectedOption.value);
  };

  const handleCallTypeEdited = (selectedOption) => {
    setEditedCallType(selectedOption.value);
  };

  const handleCallStatusEdited = (selectedOption) => {
    setEditedCallStatus(selectedOption.value);
  };

  const handleClientCommentsEdited = (e) => {
    setEditedComments(e.target.value);
  };

  const handleAgentNotesEdited = (e) => {
    setEditedAgentNotes(e.target.value);
  };

  const handleCancellationReasonEdited = (e) =>
    setEditedCancellationReason(e.target.value);

  const handleScheduledDateEdited = (e) =>
    setEditedScheduledDate(e.target.value);

  const handleScheduledFromEdited = (e) =>
    setEditedScheduledFrom(e.target.value);

  const handleScheduledToEdited = (e) => setEditedScheduledTo(e.target.value);

  const handleEditClick = (log) => {
    setEditingLogId(log.id);

    setEditedActivityType(log.activity_type?.id || "");
    setEditedCallType(log.call_type?.id || "");
    setEditedCallStatus(log.call_status?.id || "");
    setEditedComments(log.comment ?? "");
    setEditedAgentNotes(log.description ?? "");

    const meta = log.metadata ?? {};
    setEditedCancellationReason(meta.cancellation_reason ?? "");
    setEditedScheduledDate(meta.scheduled_date ?? "");
    setEditedScheduledFrom(meta.scheduled_from ?? "");
    setEditedScheduledTo(meta.scheduled_to ?? "");
  };

  const handleCallTypeChange = (selectedOption) => {
    setSelectedCallType(selectedOption ? selectedOption.value : null);
    if (selectedOption) {
      setErrors((prevErrors) => ({ ...prevErrors, callType: "" }));
    }
  };

  const handleCallStatusChange = (selectedOption) => {
    setSelectedCallStatus(selectedOption ? selectedOption.value : null);
    if (selectedOption) {
      setErrors((prevErrors) => ({ ...prevErrors, callStatus: "" }));
    }
  };

  const handleActivityTypeChange = (selectedOption) => {
    setSelectedActivityType(selectedOption ? selectedOption.value : null);
    if (selectedOption) {
      setErrors((prevErrors) => ({ ...prevErrors, activityType: "" }));
    }
  };

  const handleClientCommentsChange = (e) => {
    setClientComments(e.target.value);
  };

  const handleAgentNotesChange = (e) => {
    setAgentNotes(e.target.value);
  };

  const baseUrl = "https://estbn.com/EstbnNew/public";

  const getActivityTypes = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/portal/activity_types`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.activityTypes);
      setActivityTypes(response.data.data.activityTypes);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getCallTypes = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/portal/call_types`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.call_types);
      setCallTypes(response.data.data.call_types);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getCallStatus = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/portal/call_statuses`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.call_statuses);
      setCallStatus(response.data.data.call_statuses);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getActivityLogs = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/portal/orders/${id}/activity-logs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data);
      setActivityLogs(response.data.data.activity_logs);
    } catch (error) {
      console.log(error.message);
    }
  };

  const [errors, setErrors] = useState({
    callType: "",
    callStatus: "",
    activityType: "",
  });

  const onSubmit = async () => {
    const newErrors = {};

    if (!selectedCallType) newErrors.callType = "Call Type is required";
    if (!selectedCallStatus) newErrors.callStatus = "Call Status is required";
    if (!selectedActivityType)
      newErrors.activityType = "Activity Type is required";

    // validation for schedule types
    const selectedActObj = activityTypes.find(
      (a) => a.id === selectedActivityType
    );

    if (
      selectedActObj?.title === "Schedule Order" ||
      selectedActObj?.title === "Reschedule Order"
    ) {
      if (!scheduledDate)
        newErrors.scheduledDate = "Scheduled date is required";
      if (!scheduledFrom) newErrors.scheduledFrom = "From time is required";
      if (!scheduledTo) newErrors.scheduledTo = "To time is required";
    }

    // validation for cancel type
    if (selectedActObj?.title === "Cancel Order") {
      if (!cancellationReason)
        newErrors.cancellationReason = "Reason is required";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const activityData = new FormData();

    activityData.append("loggable_type", "doorstep_order");
    activityData.append("loggable_id", id);
    activityData.append("activity_type_id", selectedActivityType);
    activityData.append("description", agentNotes);
    activityData.append("comment", clientComments);
    activityData.append("call_status_id", selectedCallStatus);
    activityData.append("call_type_id", selectedCallType);

    // add schedule fields
    if (
      selectedActObj?.title === "Schedule Order" ||
      selectedActObj?.title === "Reschedule Order"
    ) {
      activityData.append("scheduled_date", scheduledDate);
      activityData.append("scheduled_from", scheduledFrom);
      activityData.append("scheduled_to", scheduledTo);
    }

    // add cancel field
    if (selectedActObj?.title === "Cancel Order") {
      activityData.append("cancellation_reason", cancellationReason);
    }
    try {
      const response = await axios.post(
        `${baseUrl}/api/portal/activity_logs`,
        activityData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
       console.log(response)
      toast.success("Activity added successfully", { autoClose: 3000 });
      toggleActivityModal();
      getActivityLogs();
    } catch (error) {
      console.log(error)
      toast.error(error.response.data.errors.error || "Failed to add activity");
    }
  };

  const handleSaveClick = async (id, log) => {
    // keep UI state
    // we can keep editing state while request in progress if you want a spinner
    const editedData = new FormData();
    editedData.append("_method", "PATCH");

    // activity fields (we populated edited states on edit click)
    editedData.append(
      "activity_type_id",
      editedActivityType || log.activity_type?.id || ""
    );
    editedData.append("description", editedAgentNotes ?? "");
    editedData.append("comment", editedComments ?? "");
    editedData.append(
      "call_status_id",
      editedCallStatus || log.call_status?.id || ""
    );
    editedData.append(
      "call_type_id",
      editedCallType || log.call_type?.id || ""
    );

    // Determine activity title to know which metadata to append
    const actTitle =
      activityTypes.find(
        (a) => a.id === (editedActivityType || log.activity_type?.id)
      )?.title || log.activity_type?.title;

    // add metadata fields according to type
    if (actTitle === "Cancel Order") {
      // send cancellation reason (either edited or existing)
      editedData.append(
        "cancellation_reason",
        editedCancellationReason ?? log.metadata?.cancellation_reason ?? ""
      );
    }

    if (actTitle === "Schedule Order" || actTitle === "Reschedule Order") {
      editedData.append(
        "scheduled_date",
        editedScheduledDate ?? log.metadata?.scheduled_date ?? ""
      );
      editedData.append(
        "scheduled_from",
        editedScheduledFrom ?? log.metadata?.scheduled_from ?? ""
      );
      editedData.append(
        "scheduled_to",
        editedScheduledTo ?? log.metadata?.scheduled_to ?? ""
      );
    }

    try {
      const response = await axios.post(
        `${baseUrl}/api/portal/activity_logs/${id}`,
        editedData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.info("Activity Updated successfully", { autoClose: 3000 });

      // close edit mode for that log
      setEditingLogId(null);

      // optionally clear edited fields (so next edit starts clean)
      setEditedActivityType("");
      setEditedCallType("");
      setEditedCallStatus("");
      setEditedComments("");
      setEditedAgentNotes("");
      setEditedCancellationReason("");
      setEditedScheduledDate("");
      setEditedScheduledFrom("");
      setEditedScheduledTo("");

      // refresh logs
      getActivityLogs();
    } catch (error) {
      toast.error("Failed to update activity");
      console.error("Error submitting activity log", error);
    }
  };

  const [logIdToDelete, setLogIdToDelete] = useState(null);

  const handleDeleteActivity = async () => {
    if (!logIdToDelete) return;

    try {
      await axios.delete(
        `${baseUrl}/api/portal/activity_logs/${logIdToDelete}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.warning("Activity Deleted successfully", { autoClose: 3000 });
      handleDeleteClose();
      getActivityLogs();
    } catch (error) {
      toast.error(error.message);
      console.log(error.message);
    } finally {
      // setShowModal(false);
      setLogIdToDelete(null);
    }
  };

  const confirmDelete = (logId) => {
    setLogIdToDelete(logId);
    setShowDelete(true);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setLogIdToDelete(null);
  };

  const navigate = useNavigate();

  const goToOrderDetails = () => {
    navigate(`/orders/${id}`);
  };

  const goToComments = () => {
    navigate(`/comments/${id}`);
  };

  const goToCheckBefore = () => {
    navigate(`/checkBefore/${id}`);
  };

  const goToCheckAfter = () => {
    navigate(`/checkAfter/${id}`);
  };

  const modifyDate = (date) => {
    return new Date(date).toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };

  useEffect(() => {
    getActivityTypes();
    getCallTypes();
    getCallStatus();
    getActivityLogs();
  }, []);

  return (
    <>
      {/* Delete Activity Modal  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this activity?"}
        deleteFunction={handleDeleteActivity}
      />
      {/* Add Activity Modal  */}
      {isActivityModal && (
        <div
          className="modal fade show"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog orderDetails-modal" role="document">
            <div className="modal-content activity-modalContent">
              <div className="modal-header activity-modalHeader">
                <p
                  className="modal-title mx-2 fs-3 fw-semibold"
                  id="exampleModalLabel"
                >
                  Add Activity
                </p>
              </div>
              <div className="modal-body activity-modalBody px-3 py-2">
                <div className=" d-flex flex-wrap justify-content-between align-items-center mt-1 mx-2">
                  <div className="call-type" style={{ width: "32%" }}>
                    <label className="text-muted" htmlFor="">
                      Call Type
                    </label>
                    <Select
                      id="Call Type"
                      options={callTypes.map((type) => ({
                        value: type.id,
                        label: (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span>{type.name}</span>
                          </div>
                        ),
                      }))}
                      onChange={handleCallTypeChange}
                      value={
                        selectedCallType
                          ? {
                              value: selectedCallType,
                              label: (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span>
                                    {
                                      callTypes.find(
                                        (type) => type.id === selectedCallType
                                      ).name
                                    }
                                  </span>
                                </div>
                              ),
                            }
                          : null
                      }
                      className={`my-2 ${errors.callType ? "is-invalid" : ""}`}
                    />
                    {errors.callType && (
                      <div className="text-danger">{errors.callType}</div>
                    )}
                  </div>
                  <div className="call-status" style={{ width: "32%" }}>
                    <label className=" text-muted" htmlFor="">
                      Call Status
                    </label>
                    <Select
                      id="call-status"
                      options={callStatus.map((status) => ({
                        value: status.id,
                        label: (
                          <div>
                            <span className="p-1">{status.name}</span>
                          </div>
                        ),
                      }))}
                      onChange={handleCallStatusChange}
                      value={
                        selectedCallStatus
                          ? {
                              value: selectedCallStatus,
                              label: callStatus.find(
                                (status) => status.id === selectedCallStatus
                              ).name,
                            }
                          : null
                      }
                      className={`my-2 ${
                        errors.callStatus ? "is-invalid" : ""
                      }`}
                    />
                    {errors.callStatus && (
                      <div className="text-danger">{errors.callStatus}</div>
                    )}
                  </div>
                  <div className="activity-type" style={{ width: "32%" }}>
                    <label className="text-muted" htmlFor="">
                      Activity Type
                    </label>
                    <Select
                      id="Activity Type"
                      options={activityTypes.map((actType) => ({
                        value: actType.id,
                        label: (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span>{actType.title}</span>
                          </div>
                        ),
                      }))}
                      onChange={handleActivityTypeChange}
                      value={
                        selectedActivityType
                          ? {
                              value: selectedActivityType,
                              label: (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span>
                                    {
                                      activityTypes.find(
                                        (actType) =>
                                          actType.id === selectedActivityType
                                      ).title
                                    }
                                  </span>
                                </div>
                              ),
                            }
                          : null
                      }
                      className={`my-2 ${
                        errors.activityType ? "is-invalid" : ""
                      }`}
                    />
                    {errors.activityType && (
                      <div className="text-danger">{errors.activityType}</div>
                    )}
                  </div>
                </div>
                {/* CONDITIONAL FIELDS BASED ON ACTIVITY TYPE */}
                {selectedActivityType &&
                  (() => {
                    const selectedActObj = activityTypes.find(
                      (act) => act.id === selectedActivityType
                    );
                    if (!selectedActObj) return null;
                    // If schedule or reschedule
                    if (
                      selectedActObj.title === "Schedule Order" ||
                      selectedActObj.title === "Reschedule Order"
                    ) {
                      return (
                        <div className="mx-2 mb-1">
                          <div className="d-flex flex-wrap justify-content-between align-items-center">
                            <div style={{ width: "32%" }}>
                              <label className="text-muted">
                                Scheduled Date
                              </label>
                              <input
                                type="date"
                                className={`form-control my-2 ${
                                  errors.scheduledDate ? "is-invalid" : ""
                                }`}
                                value={scheduledDate}
                                onChange={(e) =>
                                  setScheduledDate(e.target.value)
                                }
                              />
                              {errors.scheduledDate && (
                                <div className="text-danger">
                                  {errors.scheduledDate}
                                </div>
                              )}
                            </div>
                            <div style={{ width: "32%" }}>
                              <label className="text-muted">From</label>
                              <input
                                type="time"
                                className={`form-control my-2 ${
                                  errors.scheduledFrom ? "is-invalid" : ""
                                }`}
                                value={scheduledFrom}
                                onChange={(e) =>
                                  setScheduledFrom(e.target.value)
                                }
                              />
                              {errors.scheduledFrom && (
                                <div className="text-danger">
                                  {errors.scheduledFrom}
                                </div>
                              )}
                            </div>
                            <div style={{ width: "32%" }}>
                              <label className="text-muted">To</label>
                              <input
                                type="time"
                                className={`form-control my-2 ${
                                  errors.scheduledTo ? "is-invalid" : ""
                                }`}
                                value={scheduledTo}
                                onChange={(e) => setScheduledTo(e.target.value)}
                              />
                              {errors.scheduledTo && (
                                <div className="text-danger">
                                  {errors.scheduledTo}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    }
                    // If cancel
                    if (selectedActObj.title === "Cancel Order") {
                      return (
                        <div className="form-group activity-modal-form-group mx-2">
                          <label className="text-muted">
                            Cancellation Reason
                          </label>
                          <textarea
                            className={`form-control my-2 ${
                              errors.cancellationReason ? "is-invalid" : ""
                            }`}
                            rows="4"
                            placeholder="Enter cancellation reason"
                            value={cancellationReason}
                            onChange={(e) =>
                              setCancellationReason(e.target.value)
                            }
                          ></textarea>
                          {errors.cancellationReason && (
                            <div className="text-danger">
                              {errors.cancellationReason}
                            </div>
                          )}
                        </div>
                      );
                    }
                    return null;
                  })()}
                <div className="form-group activity-modal-form-group mx-2">
                  <label for="comment" className="text-muted">
                    Client Comments
                  </label>
                  <textarea
                    className="my-2 form-control"
                    rows="5"
                    placeholder="Add Comments"
                    id="comment"
                    onChange={handleClientCommentsChange}
                  ></textarea>
                </div>
                <div className="form-group activity-modal-form-group mx-2">
                  <label for="agent" className=" my-0 text-muted">
                    Agent Notes
                  </label>
                  <textarea
                    className="my-2 form-control"
                    rows="5"
                    placeholder="Add Notes"
                    id="agent"
                    onChange={handleAgentNotesChange}
                  ></textarea>
                </div>
                {activityLogs && (
                  <div className="mx-2">
                    <p className=" fw-semibold my-3">Last activities</p>
                    <table className="table border border-1 my-0 ">
                      <thead>
                        <tr>
                          <th scope="col">Date</th>
                          <th scope="col">Call Type</th>
                          <th scope="col">Call Status</th>
                          <th scope="col">Activity Type</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      {activityLogs.map((log) => {
                        return (
                          <tbody>
                            <tr>
                              <td>{modifyDate(log.created_at)}</td>
                              <td>
                                <i className="fa-solid fa-phone px-2"></i>
                                <span>{log.call_type?.name}</span>
                              </td>
                              <td>{log.call_status?.name}</td>
                              <td>
                                <i
                                  className="fa-solid fa-circle-check px-2"
                                  style={{ color: "blue" }}
                                ></i>
                                <span>{log.activity_type?.title}</span>
                              </td>
                              <td>
                                <i
                                  onClick={() => toggleComments(log.id)}
                                  className={`fa-solid fa-chevron-${
                                    isCommentsVisible[log.id] ? "up" : "down"
                                  } `}
                                ></i>
                              </td>
                            </tr>
                            {isCommentsVisible[log.id] && (
                              <tr>
                                <td colSpan="5">
                                  <div className="bg-light p-2 d-flex justify-content-start ">
                                    <div className="d-flex flex-column align-items-start">
                                      <p className="fw-semibold text-muted ">
                                        Client Comments
                                      </p>
                                      <p className="fw-semibold text-muted my-0">
                                        Agent Notes
                                      </p>
                                    </div>
                                    <div className="d-flex flex-column align-items-start">
                                      <p className=" mx-3">{log.comment}</p>
                                      <p className="mx-3 my-0">
                                        {log.description}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        );
                      })}
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer d-flex justify-content-evenly">
                <button
                  type="button"
                  className="btn btn-dark fs-6  "
                  onClick={onSubmit}
                  style={{ width: "30%" }}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-outline-dark fs-6  "
                  onClick={toggleActivityModal}
                  style={{ width: "30%" }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Head Details */}
      <HeadOrderDetails />
      {/* Details Filteration */}
      <div className="details-filter mx-4">
        <button onClick={goToOrderDetails} className="btn">
          Order Details
        </button>
        <button className="btn bg-black text-white">Activity logs</button>
        <button className="btn" onClick={goToComments}>
          Client Comments
        </button>
        {user.operator.roles[0].name === "outbound-agent" ? (
          ""
        ) : (
          <>
            <button className="btn" onClick={goToCheckBefore}>
              Check Body Before
            </button>
            <button className="btn" onClick={goToCheckAfter}>
              Check Body After
            </button>
          </>
        )}
      </div>
      {/* ActivityLog Details  */}
      <div className=" Activity Details">
        <div className="row m-4  justify-content-between">
          <div className=" col-sm-12 col-md-8 border border-1 rounded-2">
            {/* Add Activity */}
            <div className="order-activity-container p-2">
              <h3>Activity Logs</h3>
              <button
                onClick={toggleActivityModal}
                className="btn border border-1 text-muted add-activity-btn"
              >
                <i className="fa-solid fa-plus fw-light mx-1"></i> Add Activity
              </button>
            </div>
            {/* Activity Logs  */}
            {activityLogs && activityLogs.length > 0 ? (
              <div className="activity-log-container">
                {activityLogs.map((log) => {
                  return (
                    <div
                      key={log.id}
                      className="activity-log-item d-flex flex-column flex-md-row mt-3 mx-1"
                    >
                      <div className=" col-md-3 pt-2 fw-semibold text-center mb-3 mb-md-0 ">
                        <div>
                          <p className="my-2">{modifyDate(log.created_at)}</p>
                          <p>{log.operator?.name}</p>
                        </div>
                      </div>
                      <div className="col-md-9 px-3 mx-2 border-start border-2 activity-log">
                        <i className="fa-solid fa-circle activity-log-icon fa-xs"></i>
                        {/* type , activity , status */}
                        <div className="row">
                          {/* type */}
                          <div className="col-4">
                            <div className="call-type">
                              <label className="text-muted" htmlFor="">
                                Call Type
                              </label>
                              <Select
                                id="Call Type"
                                options={callTypes.map((type) => ({
                                  value: type.id,
                                  label: (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span>{type.name}</span>
                                    </div>
                                  ),
                                }))}
                                onChange={handleCallTypeEdited}
                                value={
                                  editingLogId === log.id && editedCallType
                                    ? {
                                        value: editedCallType,
                                        label: callTypes.find(
                                          (c) => c.id === editedCallType
                                        )?.name,
                                      }
                                    : log.call_type
                                    ? {
                                        value: log.call_type.id,
                                        label: log.call_type.name,
                                      }
                                    : null
                                }
                                isDisabled={editingLogId !== log.id}
                                className="my-2 small"
                              />
                            </div>
                          </div>
                          {/* status */}
                          <div className="col-4">
                            <div className="call-status">
                              <label className=" text-muted" htmlFor="">
                                Call Status
                              </label>
                              <Select
                                id="call-status"
                                options={callStatus.map((status) => ({
                                  value: status.id,
                                  label: (
                                    <div>
                                      <span className="p-1">{status.name}</span>
                                    </div>
                                  ),
                                }))}
                                onChange={handleCallStatusEdited}
                                value={
                                  editingLogId === log.id && editedCallStatus
                                    ? {
                                        value: editedCallStatus,
                                        label: callStatus.find(
                                          (c) => c.id === editedCallStatus
                                        )?.name,
                                      }
                                    : log.call_status
                                    ? {
                                        value: log.call_status.id,
                                        label: log.call_status.name,
                                      }
                                    : null
                                }
                                isDisabled={editingLogId !== log.id}
                                className="my-2"
                              />
                            </div>
                          </div>
                          {/* activity */}
                          <div className="col-4">
                            <div className="activity-type">
                              <label className="text-muted" htmlFor="">
                                Activity Type
                              </label>
                              <Select
                                id="Activity Type"
                                options={activityTypes.map((actType) => ({
                                  value: actType.id,
                                  label: (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span>{actType.title}</span>
                                    </div>
                                  ),
                                }))}
                                onChange={handleActivityTypeEdited}
                                value={
                                  editingLogId === log.id && editedActivityType
                                    ? {
                                        value: editedActivityType,
                                        label: activityTypes.find(
                                          (c) => c.id === editedActivityType
                                        )?.title,
                                      }
                                    : log.activity_type
                                    ? {
                                        value: log.activity_type.id,
                                        label: log.activity_type.title,
                                      }
                                    : null
                                }
                                isDisabled={editingLogId !== log.id}
                                className="my-2"
                              />
                            </div>
                          </div>
                        </div>
                        {/* comments & notes */}
                        <div className="row">
                          {/* comments  */}
                          <div className="col-6">
                            <div className="form-group activity-form-group client-comments">
                              <label for="comment" className=" text-muted">
                                Client Comments
                              </label>
                              <textarea
                                className="form-control my-2"
                                rows="2"
                                placeholder="Write client comments"
                                id="comment"
                                onChange={handleClientCommentsEdited}
                                value={
                                  editingLogId === log.id
                                    ? editedComments
                                    : log.comment
                                }
                                disabled={editingLogId !== log.id}
                              ></textarea>
                            </div>
                          </div>
                          {/* notes  */}
                          <div className="col-6">
                            <div className="form-group activity-form-group agent-notes">
                              <label for="agent" className=" text-muted">
                                Agent Notes
                              </label>
                              <textarea
                                className="form-control mt-2"
                                rows="2"
                                placeholder="Write client comments"
                                id="agent"
                                onChange={handleAgentNotesEdited}
                                value={
                                  editingLogId === log.id
                                    ? editedAgentNotes
                                    : log.description
                                }
                                disabled={editingLogId !== log.id}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        {/* CONDITIONAL METADATA FIELDS (shown only when editing this log) */}
                        {editingLogId === log.id &&
                          (() => {
                            const actTitle =
                              activityTypes.find(
                                (a) => a.id === editedActivityType
                              )?.title || log.activity_type?.title;
                            if (actTitle === "Cancel Order") {
                              return (
                                <div className="form-group mx-2 my-2">
                                  <label className="text-muted fw-semibold">
                                    Cancellation Reason
                                  </label>
                                  <textarea
                                    className="form-control my-2"
                                    rows="2"
                                    placeholder="Enter cancellation reason"
                                    value={editedCancellationReason}
                                    onChange={handleCancellationReasonEdited}
                                  />
                                </div>
                              );
                            }
                            if (
                              actTitle === "Schedule Order" ||
                              actTitle === "Reschedule Order"
                            ) {
                              return (
                                <div className="row">
                                  <div className="col-4">
                                    <label className="text-muted">
                                      Scheduled Date
                                    </label>
                                    <input
                                      type="date"
                                      className="form-control my-2"
                                      value={editedScheduledDate}
                                      onChange={handleScheduledDateEdited}
                                    />
                                  </div>
                                  <div className="col-4">
                                    <label className="text-muted">From</label>
                                    <input
                                      type="time"
                                      className="form-control my-2"
                                      value={editedScheduledFrom}
                                      onChange={handleScheduledFromEdited}
                                    />
                                  </div>
                                  <div className="col-4">
                                    <label className="text-muted">To</label>
                                    <input
                                      type="time"
                                      className="form-control my-2"
                                      value={editedScheduledTo}
                                      onChange={handleScheduledToEdited}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            return null;
                          })()}
                        <div className="my-3 d-flex justify-content-end">
                          {editingLogId === log.id ? (
                            <button
                              className="btn btn-dark px-4"
                              onClick={() => handleSaveClick(log.id, log)}
                            >
                              Save
                            </button>
                          ) : (
                            <button
                              className="btn btn-dark px-4"
                              onClick={() => handleEditClick(log)}
                            >
                              Edit
                            </button>
                          )}
                          <button
                            onClick={() => confirmDelete(log.id)}
                            className="btn btn-danger px-3 ms-3"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <NotFound
                paragraphText={
                  "No activities yet. All your activities will appear here once you get started."
                }
              />
            )}
          </div>
          {/* SideOrderDetails  */}
          <SideOrderDetails />
        </div>
      </div>
    </>
  );
}
